import type { Root } from 'mdast';
import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

import { dataIdMap } from './remark-constants';
import { setHTMLProperties } from './remark-helpers';
import type { ChatAssistantMessage } from '../../chat-types';

/**
 * This plugin adds citation indices to anchor nodes that are citations
 * (links starting with #).
 */
export const remarkCitation: Plugin<
  [
    {
      message: ChatAssistantMessage;
      pluginState: { citationIndex: number };
      threadId: UUID | null;
    },
  ],
  Root
> = ({ message, pluginState, threadId }) => {
  return tree => {
    visit(tree, 'link', node => {
      // Only process citation links (those starting with #).
      if (node.url?.startsWith('#')) {
        pluginState.citationIndex++; // Mutate shared state across blocks
        setHTMLProperties(node, {
          [dataIdMap.citationIndex]: pluginState.citationIndex,
          [dataIdMap.messageId]: message.id,
          [dataIdMap.threadId]: threadId,
        });
      }
    });
  };
};
